// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._2rko1qi0{border-radius:var(--ds-radius-medium,6px)}._189ee4h9{border-width:var(--ds-border-width,1px)}\n._1dqonqa1{border-style:solid}\n._1h6dn5am{border-color:var(--ds-border)}\n._1bsb1osq{width:100%}\n._1ul9uuw1{min-width:200px}\n._4t3i1osq{height:100%}\n._bfhk143w{background-color:var(--ds-surface-raised)}\n._vchhusvi{box-sizing:border-box}", ""]);
// Exports
module.exports = exports;
